import apiClient from '../api';

const base = '/feedback';

const list = (params) => apiClient.get(base + '/requests', { params });
const create = (data) => apiClient.post(base + '/requests', data);
const get = (id) => apiClient.get(`${base}/requests/${id}`);
const toggleVote = (id) => apiClient.post(`${base}/requests/${id}/votes`);
const update = (id, data) => apiClient.patch(`${base}/requests/${id}`, data);
const ownerEdit = (id, data) => apiClient.patch(`${base}/requests/${id}/edit`, data);
const remove = (id) => apiClient.delete(`${base}/requests/${id}`);
const stats = () => apiClient.get(base + '/stats');

export default { list, create, get, toggleVote, update, ownerEdit, remove, stats };


